import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import LogsTable from "./LogsTable";
import FullPageLoader from "components/common/FullPageLoader";
import { fetchInterpreterAppointmentView } from "slices/interpreter/appointmentSlice";
import { fetchInterpreterAppointmentLogs } from "slices/interpreter/appointmentSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import toast from "react-hot-toast";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import CouldNotCover from "components/appointment/CouldNotCover";
import DonotCover from "components/appointment/DonotCover";
import CancelModal from "components/appointment/CancelModal";
import { setActionAssign } from "slices/actionButtonSlice";
import ViewTable from "views/appointment/view/ViewTable";
import AppointmentInstructionsLink from 'components/common/AppointmentInstructionsLink';
import { setInterpreterIframeUrl } from "../../../slices/interpreter/interpreterIframeSlice";
import Api from "services/api";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Video } from "lucide-react";

const AppointmentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [donotCover, setDonotCover] = React.useState(false);
  const [couldNotCover, setCouldNotCover] = React.useState(false);
  const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
  const [recordingUrl, setRecordingUrl] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);

  const callViewApi = async () => {
    const callBack = (success, message, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
        console.log(data);
      } else {
        console.log(message);
      }
    };

    dispatch(fetchInterpreterAppointmentView(id, callBack));
  };

  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
        console.log(data);
      } else {
        console.log(message);
      }
      // setLogs()
    };
    dispatch(fetchInterpreterAppointmentLogs(id, callBack));
  };

  React.useEffect(() => {
    setLoading(true);
    callViewApi();
    // fetchLogs();
  }, [id]);
  const handleCancel = () => {
    setCancelModal(true);
  };
  const handleCloseCancel = () => {
    setCancelModal(false);
  };
  const handleDonotCover = () => {
    setDonotCover(true);
  };
  const handleCloseDonotCover = () => {
    setDonotCover(false);
  };
  const handleCouldNotCover = () => {
    setCouldNotCover(true);
  };
  const handleCloseCouldNotCover = () => {
    setCouldNotCover(false);
  };
  const handleOpenCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(true);
  };
  const handleCloseCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(false);
  };
  const handleSubmit = (data, end_point, callBack) => {
    setLoading(true);
    const submitCallback = (success, message) => {
      callBack && callBack();
      if (success) {
        handleCloseCancel();
        handleCloseDonotCover();
        handleCloseCouldNotCover();
        handleCloseCheckinCheckoutModal();
        callViewApi();
        fetchLogs();
        toast.success(message, {
          className: "successToast",
        });
        setLoading(false);
      } else {
        toast.error(message, { className: "errorToast" });
        setLoading(false);
      }
    };
    dispatch(setActionAssign(id, data, end_point, submitCallback));
  };

  const appointmentId = id;

  //   Join Video Call handler for interpreter
  const handleInterpreterJoinVideoCall = async () => {
    try {
      const response = await Api.interpreterjoinVideoCall(appointmentId);
      if (response?.status === 200) {
        const iframeUrl = response?.data?.data?.iframe_url;
        dispatch(setInterpreterIframeUrl(iframeUrl));
        navigate(`join-room-call`);
        // console.log("Joined successfully:", response);
      } else {
        const errorMsg = response?.data?.statusText || response?.data?.message || response?.data?.error;
        console.error("Failed to join:", errorMsg);
        toast.error(errorMsg, { className: "errorToast" });
      }
    } catch (err) {
      console.error("Error joining video call:", err);
    }
  };

  React.useEffect(() => {
    if (item) {
      console.log("Recording:", item?.appointment_details?.recording);
    } else {
      console.log("Recording not available");
    }
  }, [item]);

  const showRecordingPopup = () => {
    if (item?.appointment_details?.recording) {
      setRecordingUrl(item?.appointment_details?.recording);
      setShowModal(true);
    } else {
      toast.error("Recording not available for this appointment.", {
        className: "errorToast",
      });
    }
  };

  return (
    <div className="content" style={{}}>
      {loading && <FullPageLoader />}
      <div className="card_table view_table_custom">
        <div className="row_main_head">
          <h2 className={`main_heading`}>View Appointment </h2>
          <div className="text-transform-capitalize main_heading">
            Status : {item?.status?.replace(/_/g, ' ')}
          </div>
        </div>

        <div className="row_table_head">
          <div className="result-foot">
            <span>Appointment ID : {item?.appid}</span>
          </div>
        </div>

        <div className="row-primary flex-wrap justify-content-between">
          <div className="row-primary flex-wrap">
            {item?.status !== "completed" && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText="Cancel"
                handleSubmit={handleCancel}
              />
            )}
            {item?.status !== "cancelled" && (
              <SubmitButton
                buttonType="button"
                className="Cancle_button"
                btnText="Checkin / checkout"
                data-bs-toggle="modal"
                data-bs-target="#checkinCheckoutAdjustmentModal"
                handleSubmit={handleOpenCheckinCheckoutModal}
              />
            )}
          </div>

          {/* Join Video Call & View Recording Buttons  */}
          <div className="row-primary flex-wrap">
            {item?.appointment_details?.recording && (
              <SubmitButton
                className="Cancle_button"
                btnText="View Recording"
                handleSubmit={showRecordingPopup}
              />
            )}

            {item.type === "VRI" && (
              <SubmitButton
                className="green"
                btnText="Join Video Call"
                icon={<Video />}
                handleSubmit={handleInterpreterJoinVideoCall}
              />
            )}

            <AppointmentInstructionsLink />
          </div>
        </div>

        <ViewTable item={item} />
      </div>

      <CancelModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <DonotCover
        isOpen={donotCover}
        onClose={handleCloseDonotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CouldNotCover
        isOpen={couldNotCover}
        onClose={handleCloseCouldNotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CheckinCheckoutAdjustmentModal
        isOpen={checkinCheckoutModal}
        handleClose={handleCloseCheckinCheckoutModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        onSubmit={handleSubmit}
        item={item}
        loader={loading}
      />
      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default AppointmentView;
